const teamRoutes = [
  {
    name: "teamHome",
    path: "",
    component: () => import("./ListTeams.vue"),
    meta: {
      auth: true,
      title: "Team Listing",
      breadcrumb: "Team Listing",
    },
  },

  {
    name: "createTeam",
    path: "create",
    component: () => import("./CreateTeam.vue"),
    meta: {
      auth: true,
      title: "Add Team",
      breadcrumb: "Add Team",
    },
  },

  {
    name: "editTeam",
    path: ":id/edit",
    component: () => import("./EditTeam.vue"),
    meta: {
      auth: true,
      title: "Edit Team",
      breadcrumb: "Edit Team",
    },
  },
];

export default teamRoutes;
